import React from "react";
import
{
    Form,
    Button,
    Modal,
    ModalHeader,
    ModalBody
} from "reactstrap";

import InputTextComponent from "../../../../components/forms/InputTextComponent";
const stringUtil = require("../../../../utils/string/stringUtil");
const translator = require("../../../../utils/translator/translator");

class VoucherCodeDialogue extends React.Component
{
    constructor(props)
    {
        super(props);
        
        this.state = {};
        this.state.voucherCode = "";
        this.state.error = "";

        this.updateVoucherCode = this.updateVoucherCode.bind(this);
        this.handleModalToggle = this.handleModalToggle.bind(this);
        this.handleModalOpen = this.handleModalOpen.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.hasErrors = this.hasErrors.bind(this);
        this.inputFieldRef = React.createRef();
    }


    updateVoucherCode(voucherCode)
    {
        this.state.voucherCode = voucherCode;
        this.state.error = "";
        this.setState({});
    }

    handleModalToggle()
    {
        if (this.props.onCancel != null)
            this.props.onCancel();
    }

    handleModalOpen()
    {
        this.inputFieldRef.current.focus();
    }

    hasErrors()
    {
        if (stringUtil.isStringNullOrEmpty(this.state.voucherCode))
        {
            this.state.error = translator.getLabel("voucher_code_cannot_be_left_empty");
        }
        else
        {
            this.state.error = "";
        }

        return !stringUtil.isStringNullOrEmpty(this.state.error);
    }

    handleSubmit(e)
    {
        e.preventDefault();
        
        if (this.hasErrors())
        {
            this.setState({});
            return;
        }

        this.props.handleSubmit(this.state.voucherCode);
    }

    render()
    {
        return (
            <Modal isOpen={true} backdrop={true} animation={false} fade={false} toggle={this.handleModalToggle} onOpened={this.handleModalOpen} size="lg">
                <ModalHeader
                    close={
                        <div>
                            <Button className="btn-cancel" onClick={this.handleModalToggle}>{translator.getLabel("cancel")}</Button>&nbsp;&nbsp;
                            <Button className="btn-ok" onClick={this.handleSubmit} form="openItemForm">{translator.getLabel("done")}</Button>
                        </div>
                    }
                >
                    <span className="window-title">{translator.getLabel("voucher_code")}</span>
                </ModalHeader>
                <ModalBody>
                    <InputTextComponent
                                    id="code"
                                    autoComplete="off"
                                    name="code"
                                    placeholder={translator.getLabel("voucher_code")}
                                    inputTextType="text"
                                    value={this.state.voucherCode}
                                    onValueChange={(value) => { this.updateVoucherCode(value) }}
                                    error={this.state.error}
                                    internalRef={this.inputFieldRef}
                                    required
                                />
                </ModalBody>
            </Modal>
        );
    }
}


export default VoucherCodeDialogue;